Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MDXEmbedProvider", {
  enumerable: true,
  get: function get() {
    return _mdxEmbedProvider.MDXEmbedProvider;
  }
});
var _mdxEmbedProvider = require("./mdx-embed-provider");